const { env } = process;
const { enecomHost } = env;
export default class EnecomUtil {
    constructor() { }
    static isEnecom() {
        const hostWithoutPort = window.location.host.replace(`:${window.location.port}`, '');
        return hostWithoutPort === enecomHost;
    }
}
